import React, { FC, ReactNode }    from 'react';
import { Icon, Popup, PopupProps } from 'semantic-ui-react';

import { Align, SemanticUIColor, SystemEvent }     from '@src/types';
import { useSystemModals }                         from '@src/hooks';
import { CORVAL_ENTITY_NAME, CORVAL_PRODUCT_NAME } from '@src/constants';
import { BasicDialog }                             from '../modals/BasicDialog';
import { BasicDialogContainer }                    from '../modals/BasicDialogContainer';
import { TextLink }                                from '../display/TextLink';
import { StyledContainer }                         from '../../containers';


export interface CorvalExternalLinkProps {
    url: string,
    content: ReactNode | string,
    openAsTab?: boolean,
    showPopup?: boolean,
    popupContent?: ReactNode | string,
    popupProps?: PopupProps,
    askBeforeLeaving?: boolean,
}

export type CorvalPreparedExternalLinkProps = Omit<CorvalExternalLinkProps, 'url'>

const defaultProps: CorvalExternalLinkProps = {
    url:              '#',
    content:          'click here',
    openAsTab:        true,
    showPopup:        true,
    popupContent:     null,
    popupProps:       {},
    askBeforeLeaving: false,
}

const CorvalExternalLink: FC<CorvalExternalLinkProps> = ( props ) => {

    let modalActions = useSystemModals();

    const handleConfirmExternalLinkClicked = ( e: SystemEvent ) => {

        e.preventDefault();
        e.stopPropagation();

        modalActions.show( (
            <BasicDialog
                cancelLabel={ 'Stay on Corval' }
                submitLabel={ 'Yes, Proceed' }
                successToastLabel={ null }
                errorToastLabel={ null }
                className={ 'no-padding' }
                controlAlign={ Align.CENTER }
                onSubmit={ () => {

                    window.open( props.url, props.openAsTab ? '_blank' : '_self' )

                } }>

                <BasicDialogContainer
                    title={ `Before you go...` }
                    titleColor={ SemanticUIColor.PURPLE }>

                    <StyledContainer textAlign={ Align.CENTER }>

                        <p>You are leaving { CORVAL_PRODUCT_NAME }'s platform and will be opening the following location in your browser { props.openAsTab ? '(as a tab)' : '' }:</p>
                        <p><TextLink><Icon name={ 'linkify' }/>{ props.url }</TextLink></p>
                        <p><strong>Do you want to proceed?</strong></p>

                    </StyledContainer>

                </BasicDialogContainer>

            </BasicDialog>

        ), { size: 'tiny' } );
    }

    return (
        <Popup size={ 'tiny' }
               disabled={ !props.showPopup }
               closeOnPortalMouseLeave={ true }
               closeOnTriggerMouseLeave={ true }
               content={ props.popupContent }
               position={ 'top center' }
               trigger={
                   props.askBeforeLeaving
                   ? <a href={ props.url } referrerPolicy={ 'no-referrer' } onClick={ handleConfirmExternalLinkClicked }>{ props.content ?? props.children }</a>
                   : <a href={ props.url } target={ props.openAsTab ? '_blank' : '_self' }>{ props.content ?? props.children }</a>
               }
               { ...props.popupProps }
        />
    );
};

CorvalExternalLink.defaultProps = defaultProps;

export { CorvalExternalLink }
